// React libs
import React, { FC, useState } from 'react';
import { Field, Form, FormikProps, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
// Components
import Button from '../../../../../../Core/Components/UiKit/Button/Button';
import FaIcon from '../../../../../../Core/Components/UiKit/Icon/FaIcon/FaIcon';
import FormHeader from '../../../../../../Core/Components/Form/FormHeader/FormHeader';
import TextFieldMia from '../../../../../../Core/Components/UiKit/Form/TextField/TextField';
import { FormAccessType } from '../../../../../../Core/Components/Form/FormFields/FormFields';
// Type
import * as Types from './PasswordProfilForm.type';
// Utils
import {
  getFormPropTypes, isDisabled,
} from '../../../../../../Core/Utils/FormUtils';

const UserPasswordForm: FC<Types.IProps> = ({
  defaultValues,
  miscData,
  miscFunctions,
  onFormSubmit,
  validationSchema,
}) => (
  <Formik
    initialValues={defaultValues}
    onSubmit={onFormSubmit}
    validationSchema={validationSchema}
    enableReinitialize
  >
    {(formikProps: FormikProps<any>) => (
      <UserPasswordFormikForm
        {...formikProps}
        miscFunctions={miscFunctions}
        miscData={miscData}
      />
    )}

  </Formik>
);

UserPasswordForm.propTypes = getFormPropTypes();

export default UserPasswordForm;


export const UserPasswordFormikForm = ({
  errors,
  isSubmitting,
  touched,
  miscData,
  setFieldValue,
  setFieldTouched
}: FormikProps<any> & any) => {
  const { t } = useTranslation(['common', 'profile']);
  const isNested = miscData?.nested ?? false
  const isNewContact = miscData?.newContact ?? false
  const [edit, setEdit] = useState<boolean>(isNested);
  const fieldContainerClasses = 'flex w-full items-center mx-2';
  const fieldContainerFieldClasses = `${fieldContainerClasses} flex-1`;

  // Handlers
  const handleReset = () => {
    setTimeout(() => {
      setEdit(false)
    }, 100);

  }
  return (
    <>
      <FormHeader
        toggleEditionMode={() => setEdit(edit => !edit)}
        isEditionMode={edit}
        title={t("profile:password.title")}
      />
      <Form data-testid='form-password-profils' className='flex w-full'>
        <div className='flex flex-col w-11/12'>
          <FormAccessType name='accountAccessType' disabled={!edit} />
          <div className={fieldContainerFieldClasses}>
            <Field
              id='accountSubjectId'
              name='accountSubjectId'
              label={t('profile:password.username')}
              component={TextFieldMia}
              color='secondary'
              className='flex-1'
              disabled={edit ? false : true}
            />
          </div>
          {!isNewContact &&
            <div className={fieldContainerFieldClasses}>
              <Field
                id='accountOldPassword'
                name='accountOldPassword'
                type='password'
                component={TextFieldMia}
                canDisplayPassword
                label={t('profile:password.oldPassword')}
                color='secondary'
                className='flex-1'
                disabled={edit ? false : true}
              />
            </div>
          }
          <div className={fieldContainerFieldClasses}>
            <Field
              id='accountNewPassword'
              name='accountNewPassword'
              type='password'
              component={TextFieldMia}
              canDisplayPassword
              label={t('profile:password.newPassword')}
              color='secondary'
              className='flex-1'
              disabled={edit ? false : true}
            />
          </div>
          <div className={fieldContainerFieldClasses}>
            <Field
              id='accountConfirmPassword'
              name='accountConfirmPassword'
              type='password'
              component={TextFieldMia}
              canDisplayPassword
              label={t('profile:password.passwordConfirmation')}
              color='secondary'
              className='flex-1'
              disabled={edit ? false : true}
            />
          </div>
          <div className={fieldContainerFieldClasses}>
            <Field
              id='accountComment'
              name='accountComment'
              component={TextFieldMia}
              label={t('profile:common.comment')}
              color='secondary'
              className='flex-1'
              disabled={edit ? false : true}
              multiline
            />
          </div>
          {edit && !isNested &&
            <div className={`${fieldContainerClasses} justify-center`} >
              <Button
                type='reset'
                variant='text'
                size='large'
                className='mx-2'
                onClick={handleReset}
              >
                {t("profile:common.cancel")}
              </Button>
              <Button
                type='submit'
                variant='text'
                size='large'
                className='mx-2'
                onClick={handleReset}
                disabled={isDisabled(errors, isSubmitting, touched)}
                startIcon={
                  isSubmitting ? <FaIcon name='spinner' className='fa-spin' /> : null
                }
              >
                {t("profile:common.save")}
              </Button>
            </div>
          }
        </div>
      </Form>
    </>
  );
};